export enum Modules {
  DOCTORS = "medicos",
  DOCTOR_COMPANIES = "empresas-medicas",
  BANK_ACCOUNT = "contas-bancarias",
}
